import axios from 'axios';
import { getApiUrl } from '../config/api';

const api = axios.create({
    baseURL: getApiUrl('/api/blogs'),
    timeout: 10000,
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});
export const blogApi = {
    getBlogs: async (params = {}) => {
        const response = await api.get('/', { params });
        return response.data;
    },

    getPopularBlogs: async (params = {}) => {
        const response = await api.get('/popular', { params });
        return response.data;
    },

    getBlogBySlug: async (slug) => {
        const response = await api.get(`/${slug}`);
        return response.data;
    },

    getRelatedBlogs: async (slug, params = {}) => {
        const response = await api.get(`/${slug}/related`, { params });
        return response.data;
    },

    createBlog: async (blogData) => {
        const response = await api.post('/', blogData);
        return response.data;
    },

    updateBlog: async (id, blogData) => {
        const response = await api.put(`/${id}`, blogData);
        return response.data;
    },

    deleteBlog: async (id) => {
        const response = await api.delete(`/${id}`);
        return response.data;
    },

    toggleBlogLike: async (id) => {
        const response = await api.patch(`/${id}/like`);
        return response.data;
    },

    incrementBlogView: async (id) => {
        const response = await api.patch(`/${id}/view`);
        return response.data;
    },
};

export const fetchAllBlogs = async (params = {}) => blogApi.getBlogs(params);

export default blogApi;